import { render } from "./EyeIcon.vue?vue&type=template&id=fde1b136"
import script from "./EyeIcon.vue?vue&type=script&lang=js"
export * from "./EyeIcon.vue?vue&type=script&lang=js"
script.render = render

export default script